<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="medium-width">
      <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha desde" required>
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
      <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
          Ingrese la fecha desde
      </mat-error>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha hasta" required>
      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
      <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
          Ingrese la fecha hasta
      </mat-error>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" matInput placeholder="Protocolo" formControlName="Protocol">
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #doctor matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autService">
      <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
          <mat-option *ngFor="let service of filteredServicesOptions | async" [value]="service">
              {{service.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #doctor matInput placeholder="Centro" formControlName="Center" [matAutocomplete]="autCenter">
      <mat-autocomplete #autCenter="matAutocomplete" [displayWith]="filterCompleteCenters.displayFn">
          <mat-option *ngFor="let center of filteredCentersOptions | async" [value]="center">
              {{center.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #doctor matInput placeholder="Especialidad" formControlName="Specialty" [matAutocomplete]="autSpecialty">
      <mat-autocomplete #autSpecialty="matAutocomplete" [displayWith]="filterCompleteSpecialities.displayFn">
          <mat-option *ngFor="let speciality of filteredSpecialitiesOptions | async" [value]="speciality">
              {{speciality.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #practiceRegion matInput placeholder="Práctica" formControlName="PracticeRegion" [matAutocomplete]="autPracticeRegion">
      <mat-autocomplete #autPracticeRegion="matAutocomplete" [displayWith]="filterCompletePracticesRegion.displayFn">
          <mat-option *ngFor="let practiceRegion of filteredPracticesRegionOptions | async" [value]="practiceRegion">
              {{practiceRegion.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #physician matInput placeholder="Médico" formControlName="Physician" [matAutocomplete]="autPhysician">
      <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysicians.displayFn">
          <mat-option *ngFor="let physician of filteredPhysiciansOptions | async" [value]="physician">
              {{physician.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <div class="full-width">
      <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
  <div>
      <mat-checkbox formControlName="OrderByPatient"><span>Ordenar por paciente</span> </mat-checkbox>
      <mat-checkbox formControlName="NoViewAdmissionControled"><span>Ver solo no controlado</span> </mat-checkbox>
      <mat-checkbox formControlName="ViewPreAdmission"><span>Ver admisión previa</span> </mat-checkbox>
      <mat-checkbox formControlName="ViewCancel"><span>Ver cancelados</span> </mat-checkbox>
    </div>
</form>
